const appConfig = {
  pollIntervalMsDriverLocation: 15000,
  bannerPollIntervalMs: 30 * 60 * 1000, // 30 minutes in milliseconds
  gtmId: process.env.REACT_APP_GTM_ID?.trim() || '',
  gtmRegisterPath: '/register',
}
export default appConfig
